module.exports = __webpack_public_path__ + "static/img/factorylogo.28fa2ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/factorylogo.jpg
// module id = ZzGP
// module chunks = 1